module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-precomposed.590ade25abfef9456d1026188c8fa8b1.png";